module.exports = __webpack_public_path__ + "img/m2-screenshot-11.127df479.png";